import React from 'react'

export default function Boton() {
    return (
        <button type="button" className=" bg-purple-500 text-2xl text-white hover:bg-yellow-500 py-2 px-5 mt-5 w-80 rounded-2xl">
            Conocer mas
        </button>
    )
}
